import { getValueByKeys } from './getValueByKeys';

export const searchByAdditionalValue = (keys, object, searchValue) =>
  String(getValueByKeys(keys, object)).toLowerCase().search(searchValue.toLowerCase()) >= 0;
